export default "__VITE_PUBLIC_ASSET__a1132e35__"